import { Component, HostListener, OnInit } from '@angular/core';
import { sideBar, sideBar2 } from '../../core/constants/sidebar.const';
import { assets } from '../../core/constants/assets.const';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { UserResponse } from '../../models/auth.model';

@Component({
  selector: 'mindbase-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit {

  private destroy: Subject<boolean> = new Subject<boolean>();
  protected subscriptionSubject$!: Subscription;
  protected assetsConst = assets;
  public sideBar = sideBar;
  public sideBar2 = sideBar2;
  protected profile: UserResponse | null = null;

  public innerWidth = 0;
  public sidenavWidth = 5;

  constructor(public _authService: AuthService, private router:Router) {}

  ngOnInit(): void {
    this.subscriptionSubject$ = this._authService.profileDetailsSubject
      .pipe(takeUntil(this.destroy))
      .subscribe((res: UserResponse | null) => {
        if (res !== null) {
          this.profile = res;
        }
      });
  }

  increase(): void {
    this.sidenavWidth = 15;
  }
  decrease(): void {
    this.sidenavWidth = 4;
  }
  @HostListener('window', ['$event'])
  toggleSidenav(): void {
    this.innerWidth = window.innerWidth;
    if (this.innerWidth <= 1199.98) {
      this._authService.toggleSidebarView();
    }
  }

  isRouteActive(path: any): boolean {
    const currentUrl = this.router.url.split('?')[0]; // Remove query parameters from the URL

    // Exclude specific route from being marked as active
    if (path === '/manage-tutoring/tutor-package') {
      return false;
    }

    if (currentUrl === '/manage-counselling/all-counsellors' && path === '/manage-counselling/counsellors') {
      return true;
    }

    // Check if the current URL starts with the given path
    return currentUrl.startsWith(path);
  }

}
